import React from 'react';

import ErrorScreen from './ErrorScreen';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <ErrorScreen stack={this.state.error.stack}></ErrorScreen>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
